import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../common/api/queryKeys/queries';

interface UseConsumptionPresetsConfig {
    vesselId: string;
}

export const useConsumptionPresets = ({ vesselId }: UseConsumptionPresetsConfig) => {
    return useQuery({
        ...queries.vessels.detail(vesselId)._ctx.consumptionPresets,
        throwOnError: false,
        retry: (_, error: any) => {
            return error.response?.status !== 404;
        },
        refetchOnWindowFocus: false,
    });
};
